import Api from '../api';
import { errorHandler } from '../common';

const { axios: api } = Api;

export const createConsultantRefund = (body) =>
	errorHandler(async () => {
		const data = await api.post(
			'/consultant-refund/create',
			body,
			{ headers: { 'Content-Type': 'multipart/form-data' } },
		);
		return { data: data.data };
	});

export const updateConsultantRefund = (body) =>
	errorHandler(async () => {
		const data = await api.post(
			`/consultant-refund/update`,
			body,
		);
		return { data: data.data };
	});


export const findConsultantRefund = (id) =>
	errorHandler(async () => {
		const data = await api.get(
			`/consultant-refund/find-by-consultant-id/${id}`,
		);
		return { data: data.data };
	});


export const findConsultantRefundsByMarketsAndStatus = (body) =>
	errorHandler(async () => {
		const data = await api.post(
			`/consultant-refund/find-by-markets-and-status`,
			body,
		);
		return { data: data.data };
	});
